
import { defineComponent, PropType } from 'vue';
import BaseLayoutLetsBeFriendsAndLookBook
    from '@/shared/content/blocks/call-to-action-layouts/shared/BaseLayoutLetsBeFriendsAndLookBook.vue';
import { CallToActionTileModel } from '@/types/B2BcontentServerContract';

export default defineComponent({
    name: 'CallToActionLookBookLayout',
    components: { BaseLayoutLetsBeFriendsAndLookBook },
    props: {
        content: {
            type: Object as PropType<CallToActionTileModel>,
            required: true,
        },
    },
});
